import { Controller } from "@hotwired/stimulus";
import "./component.scss";

import { DirectUpload } from "@rails/activestorage";
import { refreshCsrfToken } from "../../helpers/csrf";

const NON_CLICKABLE_CLASS = "c-direct_upload_field-not-clickable";
const HIDDEN_CLASS = "hidden";

export default class extends Controller {
  static targets = [
    "fileInput",
    "form",
    "label",
    "title",
    "loaderZone",
    "progressbar",
    "progress",
    "log",
    "abort",
    "submit",
  ];

  static values = {
    autoSubmitOnUploaded: Boolean,
  };

  connect() {}

  start() {
    this.handleInitiate();
    Array.from(this.fileInputTarget.files).forEach((file) =>
      this.uploadFile(file)
    );
  }

  async uploadFile(file) {
    const url = this.fileInputTarget.dataset.directUploadUrl;
    try {
      await refreshCsrfToken();
    } catch (error) {
      console.error("There was an error refreshing the CSRF token.", error);
      return;
    }
    const upload = new DirectUpload(file, url, this);

    upload.create((error, blob) => {
      if (error) {
        console.error("There was an error uploading the file.", error);
      } else {
        this.createHiddenInput(blob);
      }
    });
  }

  handleInitiate(event) {
    this.switchViewToLoaderZone();
    this.labelTarget.classList.add(NON_CLICKABLE_CLASS);
    this.logTarget.textContent = "Uploading (0%)…";
    this.progressTarget.style.width = "0%";
  }

  handleLoadStart(event) {
    this.logTarget.textContent = "Uploading (0%)…";
    this.progressTarget.style.width = "0%";
    this.abortTarget.disabled = false;
  }

  handleProgress(event) {
    let progressPercent = ((event.loaded / event.total) * 100).toFixed(2);
    this.progressTarget.style.width = `${progressPercent}%`;

    this.logTarget.textContent = `Uploading (${progressPercent}%)…`;
  }

  handleError(event) {
    this.labelTarget.classList.remove(NON_CLICKABLE_CLASS);
    this.switchViewToTitle();
  }

  handleLoaded(event) {
    // When the upload is finished successfully.
    this.logTarget.textContent = "Upload finished.";
    this.labelTarget.classList.remove(NON_CLICKABLE_CLASS);
    this.submitButtonEnable();
  }

  handleLoadEnd(event) {
    // When the upload is finished, no matter if it was successful or not.
    if (event.loaded !== 0) {
      this.abortTarget.disabled = true;
      this.abortTarget.classList.add(HIDDEN_CLASS);
      this.submitTarget.classList.remove(HIDDEN_CLASS);

      if (this.autoSubmitOnUploadedValue) {
        setTimeout(() => {
          this.formTarget.submit();
        }, 2500);
      }
    }
  }

  directUploadWillStoreFileWithXHR(xhr) {
    xhr.upload.addEventListener("loadstart", this.handleLoadStart.bind(this));
    this.abortTarget.addEventListener(
      "click",
      () => {
        xhr.abort();
      },
      { once: true }
    );

    // Each time a progress event is received, we update the bar
    xhr.upload.addEventListener("progress", this.handleProgress.bind(this));

    xhr.upload.addEventListener("abort", this.handleError.bind(this));
    xhr.upload.addEventListener("error", this.handleError.bind(this));
    xhr.upload.addEventListener("timeout", this.handleError.bind(this));

    xhr.upload.addEventListener("load", this.handleLoaded.bind(this));
    xhr.upload.addEventListener("loadend", this.handleLoadEnd.bind(this));
  }

  createHiddenInput(blob) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("value", blob.signed_id);
    hiddenField.name = this.fileInputTarget.name;
    this.labelTarget.appendChild(hiddenField);
    this.formTarget.removeChild(this.fileInputTarget);
  }

  submitButtonEnable() {
    this.submitTarget.disabled = false;
  }

  switchViewToLoaderZone() {
    this.loaderZoneTarget.classList.remove(HIDDEN_CLASS);
    this.titleTarget.classList.add(HIDDEN_CLASS);
    this.abortTarget.classList.remove(HIDDEN_CLASS);
  }

  switchViewToTitle() {
    this.loaderZoneTarget.classList.add(HIDDEN_CLASS);
    this.titleTarget.classList.remove(HIDDEN_CLASS);
  }

  disconnect() {
    // this.removeListeners();
  }
}
